class MenuDrawerMobile extends HTMLElement {
  constructor() {
    super();
    this.submenuLevel1 = this.querySelectorAll('.menu-drawer__navigation .submenu__level-1');
    this.primaryMenuItems = this.querySelectorAll('.menu-drawer__menu-1 > li > .menu-drawer__menu-item:not(a)');
    this.bindEvents();
  }

  setFeatured() {
    // Featured section is now a heading, no longer needs aria-expanded
    // This method is kept for backward compatibility but is no longer used
  }

  bindEvents() {
    this.primaryMenuItems.forEach((item) => item.addEventListener('click', this.onMenuItemClick.bind(this)));
    
    // Use event delegation for secondary menu items (level 2 accordion)
    this.addEventListener('click', (event) => {
      const menuItem = event.target.closest('.menu-drawer__menu-2 > li > .menu-drawer__menu-item:not(a)');
      if (menuItem) {
        event.preventDefault();
        event.stopPropagation();
        this.toggleSecondaryMenu(menuItem);
      }
    });
  }

  onMenuItemClick(event) {
    const menuItemElement = event.currentTarget;

    setTimeout(() => {
      this.openMenuDrawer(menuItemElement);
    }, 50);
  }

  toggleSecondaryMenu(menuItemElement) {
    // Get all secondary menu items in the menu-2 list
    const menu2 = menuItemElement.closest('.menu-drawer__menu-2');
    if (!menu2) return;
    
    const allSecondaryItems = menu2.querySelectorAll(':scope > li > .menu-drawer__menu-item:not(a)');
    const isCurrentlyOpen = menuItemElement.getAttribute('aria-expanded') === 'true';

    // Close all items first
    if(allSecondaryItems.length > 0) {
      allSecondaryItems.forEach(item => {
        item.setAttribute('aria-expanded', 'false');
      });
    }

    // If it wasn't open, open it now
    if (!isCurrentlyOpen) {
      menuItemElement.setAttribute('aria-expanded', 'true');
    }
  }

  openMenuDrawer(menuItemElement) {
    if (menuItemElement?.parentNode?.parentNode?.classList?.contains('menu-drawer__menu-1')) {
      const menuItems = menuItemElement?.closest('.menu-drawer__menu')?.querySelectorAll('li > .menu-drawer__menu-item:not(a)');
      menuItems.length && menuItems.forEach(item => {
        if (item.hasAttribute('aria-expanded')) {
          const linkHandle = item.getAttribute('data-link-handle');
          const submenuLevel1 = this.querySelector(`.submenu__level-1[data-link-handle="${linkHandle}"]`);
          submenuLevel1?.removeAttribute('aria-expanded');
          item.removeAttribute('aria-expanded');
        }
      });
    }

    if (menuItemElement.hasAttribute('aria-expanded')) {
      const linkHandle = menuItemElement.getAttribute('data-link-handle');
      const submenuLevel1 = this.querySelector(`.submenu__level-1[data-link-handle="${linkHandle}"]`);
      menuItemElement?.removeAttribute('aria-expanded');
      submenuLevel1?.removeAttribute('aria-expanded');
    } else {
      const linkHandle = menuItemElement.getAttribute('data-link-handle');
      const submenuLevel1 = this.querySelector(`.submenu__level-1[data-link-handle="${linkHandle}"]`);
      menuItemElement?.setAttribute('aria-expanded', true);
      submenuLevel1?.setAttribute('aria-expanded', true);
    }
  }
}

customElements.define('menu-drawer-mobile', MenuDrawerMobile);
